export const DesignSystem = Object.freeze({
    prefix: "fabric",
    shadowRootMode: "open",
    registry: customElements
});
//# sourceMappingURL=design-system.js.map